import { version } from "./version";
export const environment = {
    production: false,
    version: version,
    msalConfig: {
        auth: {
            clientId: '3ea7d140-1fef-4d80-aeb8-826012e7b9f3',
            authority: 'https://login.microsoftonline.com/b509b977-2012-4f76-92d1-32d3b96e180c/',
        }
    },
    adoApiConfig: {
        scopes: [ "499b84ac-1321-427f-aa17-267ca6975798/.default"],
        uri: 'https://dev.azure.com/wheelme',
        project: 'Intervention Sandbox', 
        apiVersion: '7.0'
    },
    dynamoDbApiConfig: {
        scopes: [ "api://93438375-7aaf-41a4-9dbb-09dfe0d08d6a/.default"],
        uri: 'https://intervention-tracker.dev.internal.wheelme-web.com/api'
    }
};

